import { Reveal } from "../Reveal";

const WORKSHOP_IMG =
  "https://images.pexels.com/photos/5894239/pexels-photo-5894239.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600";
const MATERIALS_IMG =
  "https://static.prod-images.emergentagent.com/jobs/3adc9213-dab6-4851-9c35-a0c85e7e3dfd/images/58af23d9684d3ebfe151f00158c74025ebcb80f78407499177520a01a2f0732e.png";

export const Atelier = () => {
  return (
    <section
      id="atelier"
      data-testid="atelier-section"
      className="relative py-24 md:py-40 bg-[#0F1B3D] text-[#F9F8F6] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 md:mb-24">
          <div className="lg:col-span-4">
            <Reveal>
              <span className="text-[11px] tracking-[0.3em] uppercase text-[#B8945F] font-medium">
                04 — The Atelier
              </span>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal delay={100}>
              <h2
                data-testid="atelier-heading"
                className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#F9F8F6] leading-[1.05] tracking-tight"
              >
                Two workshops. <em className="font-light text-[#B8945F]">One</em> obsession with craft.
              </h2>
            </Reveal>
          </div>
        </div>

        {/* Workshop dual layout */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Image */}
          <Reveal delay={120} className="lg:col-span-7">
            <div className="relative zoom-container">
              <img
                src={WORKSHOP_IMG}
                alt="Artisan at work in the Shoozix Agra atelier"
                data-testid="atelier-workshop-image"
                className="w-full h-[60vh] md:h-[70vh] object-cover"
              />
              <div className="absolute top-6 left-6 right-6 flex items-center justify-between text-[#F9F8F6]/85 text-[10px] tracking-[0.3em] uppercase">
                <span>Atelier · 01</span>
                <span>Agra</span>
              </div>
            </div>
          </Reveal>

          {/* Text */}
          <div className="lg:col-span-5 space-y-12">
            <Reveal delay={200}>
              <div>
                <span className="font-serif text-6xl text-[#B8945F] leading-none">Agra</span>
                <p className="mt-5 text-[15px] leading-relaxed text-[#F9F8F6]/75 max-w-md">
                  The historic capital of Indian leatherwork. Our Agra workshop houses our welted line, classic men's footwear and our most senior craftsmen — some with three generations of family knowledge in their hands.
                </p>
                <div className="mt-6 flex items-center gap-3 text-[11px] tracking-[0.25em] uppercase text-[#B8945F]">
                  <span className="w-12 h-px bg-[#B8945F]" />
                  <span>Heritage Construction</span>
                </div>
              </div>
            </Reveal>

            <Reveal delay={320}>
              <div>
                <span className="font-serif text-6xl text-[#B8945F] leading-none">Noida</span>
                <p className="mt-5 text-[15px] leading-relaxed text-[#F9F8F6]/75 max-w-md">
                  Our Noida studio runs sampling, ladies' and kids' lines, and our leather garments. It's where new ideas get shaped, photographed, perfected — and where most private label clients begin their journey with us.
                </p>
                <div className="mt-6 flex items-center gap-3 text-[11px] tracking-[0.25em] uppercase text-[#B8945F]">
                  <span className="w-12 h-px bg-[#B8945F]" />
                  <span>Sampling &amp; Studio</span>
                </div>
              </div>
            </Reveal>

            <Reveal delay={440}>
              <div className="zoom-container">
                <img
                  src={MATERIALS_IMG}
                  alt="Premium leather materials and brass hardware"
                  className="w-full aspect-[5/3] object-cover"
                />
              </div>
            </Reveal>
          </div>
        </div>

        {/* Stat strip */}
        <Reveal delay={300}>
          <div
            data-testid="atelier-stats"
            className="mt-20 md:mt-28 grid grid-cols-2 md:grid-cols-4 gap-px bg-[#F9F8F6]/10"
          >
            {[
              { n: "2", l: "Workshops" },
              { n: "120+", l: "Artisans" },
              { n: "10–14d", l: "Sample Lead Time" },
              { n: "100%", l: "Hand-finished" },
            ].map((s, i) => (
              <div
                key={i}
                className="bg-[#0F1B3D] py-10 md:py-14 px-6 flex flex-col items-start"
              >
                <span className="font-serif text-5xl md:text-6xl text-[#F9F8F6] leading-none">
                  {s.n}
                </span>
                <span className="mt-3 text-[10px] tracking-[0.3em] uppercase text-[#B8945F]">
                  {s.l}
                </span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
